/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileFolderIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Folder',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2v10h10L20 2z" />
    <path
      d="M18 33.5V23a3 3 0 0 1 3-3h4.586a2.982 2.982 0 0 1 2.121.879L30 23.172V14H19a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h11.1a2.385 2.385 0 0 1-.1-.5Z"
    />
    <path
      d="M33.5 34h-13a.5.5 0 0 1-.5-.5V26h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5ZM28 24l-1.707-1.707a1 1 0 0 0-.707-.293H21a1 1 0 0 0-1 1v1Z"
    />
  </svg>`;
};
